import React, { useEffect ,useState} from "react";
import { useNavigate } from "react-router-dom";

const Logout = ({ setIsLoggedIn }) => {
    const navigate = useNavigate();
     
    useEffect(() => {
        
        localStorage.removeItem("token"); 
        localStorage.removeItem("tutor"); 
        sessionStorage.clear(); 
        setIsLoggedIn(false);
        navigate("/login");
    }, [navigate,setIsLoggedIn]);

    return null;
};

export default Logout;
